import classNames from 'classnames';
import { CustomButton } from '../../../../features/customButton';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';

export default function Buttons({ className, modifier, buttons }) {
  return (
    <div
      className={classNames(
        'universal-modal__buttons',
        className,
        ...combineModifiers('universal-modal__buttons', modifier),
      )}
    >
      {buttons?.map((item, index) => (
        <CustomButton key={index} {...item} className={classNames(item.className, 'universal-modal__button')} />
      ))}
    </div>
  );
}
